import api from './axios';

export const warehousesApi = {
  getAll: () => api.get('/warehouses'),
  getById: (id: number) => api.get(`/warehouses/${id}`),
  getStock: (id: number) => api.get(`/warehouses/${id}/stock`),
  getProductStock: (productId: number) => api.get(`/warehouses/product/${productId}/stock`),
  create: (data: any) => api.post('/warehouses', data),
  update: (id: number, data: any) => api.put(`/warehouses/${id}`, data),
  delete: (id: number) => api.delete(`/warehouses/${id}`),
  createTransfer: (data: any) => api.post('/warehouses/transfers', data),
  getTransfers: (warehouseId?: number) =>
    api.get('/warehouses/transfers/list', { params: { warehouseId } }),
};
